module.exports = new __parcel__URL__("welcome-to-project-pages-spork-rebranding.dd069d6d.svg").toString();